export const buildUrlBase = (uri: string) => {
  return `/${uri}`;
};
